<template>
  <v-dialog
    v-model="show"
    max-width="60em"
  >
    <v-card>
      <v-card-title primary-title>
        Create New Folder
      </v-card-title>
      <v-card-text class="pa-6">
        <v-text-field
          v-model="name"
          label="Folder name"
          outlined
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          outlined
          @click.stop="show = false"
        >
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click.stop="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { createCollection } from '@/utils/collections'
export default {
  props: {
    value: Boolean,
    cusip: null
  },
  methods: {
    save: function() {
      // do axios here
      const component = this
      createCollection(component.name).then(response => {
        console.log(response)
        component.show = false
      })
    }
  },
  computed: {
    ...mapState({
      loading: 'loading'
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  data: () => ({
    name: null
  })
}
</script>
<style scoped>
td {
  padding: 4px;
}
td.label {
  font-weight: bold;
  text-align: right;
}
</style>
